/*
THIS COMPONENT IS INCLUDED IN FORM-EDIT ROLE PAGE
 -----------------------------------------*/
let PermissionsChecker = function () {

    let checkerClassName = 'permissions_container__checker';
    let mainCheckerClassName = 'permissions_container__main_checker';
    let checkerContainerName = 'permissions_container';

    let changeValOfLowerCheckers = function (mainChecker) {
        let container = getContainer(mainChecker);

        let lowerMainCheckers = container.find('.' + mainCheckerClassName);
        lowerMainCheckers.prop('checked', mainChecker.is(':checked'));

        let lowerCheckers = container.find('.' + checkerClassName);
        lowerCheckers.prop('checked', mainChecker.is(':checked'));
    };

    let changeValOfUpperCheckers = function (checker) {
        let container = checker.hasClass(mainCheckerClassName)
            ? getContainer(checker)
            : checker;

        while (container.length > 0) {
            container = getContainer(container);
            if (container.length <= 0) {
                break;
            }

            setMainCheckerVal(container);
        }
    };

    let getContainer = function (element) {
        return element.parents('.' + checkerContainerName + ':first');
    };

    let setMainCheckerVal = function (container) {
        let mainChecker = container.find( '.' + mainCheckerClassName + ':first');
        mainChecker.prop('checked', false);
        mainChecker.prop('indeterminate', false);

        let checkers = container.find('.' + checkerClassName);
        let checkedCount = 0;

        $(checkers).each(function (index, checker) {
            if ($(checker).is(':checked')) {
                checkedCount ++;
            }
        });

        if (checkedCount == checkers.length) {
            mainChecker.prop('checked', true);
        } else if (checkedCount != 0) {
            mainChecker.prop('indeterminate', true);
        }
    };

    let toggleStateIcon = function (icon) {
        if (icon.hasClass('fa-angle-left')) {
            icon.removeClass('fa-angle-left');
            icon.addClass('fa-angle-down');
        } else {
            icon.removeClass('fa-angle-down');
            icon.addClass('fa-angle-left');
        }
    };

    let init = function () {
        $(document).on('click', '.' + mainCheckerClassName, function () {
            changeValOfLowerCheckers($(this));
            changeValOfUpperCheckers($(this));
        });

        $(document).on('click', '.' + checkerClassName, function () {
            changeValOfUpperCheckers($(this));
        });

        $('.' + checkerContainerName).each(function (index, container) {
            setMainCheckerVal($(container));
        });

        $('.permissions-tab').on('click', function () {
            let icon = $(this).find('.toggle-icon');
            toggleStateIcon(icon);
        });
    };

    return {
        init: init
    };

} ();

export default PermissionsChecker;
